/**
 * The famous progressively absurd scrolling text
 * Inspired by timstech-new but weebier
 * Gets increasingly self-aware and meta the longer you watch
 */

export const heroTexts: string[] = [
  // Start normal
  'free',
  'public domain',
  'built by weebs',
  'for weebs',
  'open source',

  // Get weeby
  'powered by anime and tea',
  'fueled by Toonami nostalgia',
  'what happens when otakus learn to code',
  'born from a Toonami obsession',
  'made at 3 AM',
  'definitely not sponsored',
  'more over-engineered than a Gundam',
  'basically a giant robot but for code',

  // Get aggressive
  'take it or leave it',
  'because we fucking can',

  // Get self-aware
  'probably unnecessary',
  'definitely unnecessary',
  'extremely over-engineered',
  'overthinking as a lifestyle',
  'this site has 5 secret themes',
  'try pressing the same number key 5 times',
  'go ahead, we\'ll wait',

  // You're still here?
  'you\'re still reading this?',
  'impressive dedication',
  'this is part of the experience',
  'the scrolling text never ends',
  'just like a shonen anime',
  'it just keeps going',
  'and going',
  'and going',

  // Get meta
  'self-referential and proud',
  'aware of how ridiculous this is',
  'embracing the chaos',
  'no regrets',
  'well, maybe some regrets',
  'there is no exit',
  'welcome to the madness',
  'one of us, one of us',

  // Peak absurdity
  'I\'m running out of ideas',
  'help I\'m trapped in a text array factory',
  'this is what happens at 3 AM',
  'sleep is for the weak',
  'do androids dream of electric weebs?',
  'the real CommercialBreaker was the friends we made along the way',
  'still here? impressive',
  'dedication level: watching all of One Piece',
  'commitment level: reading the Berserk manga',
  'you could be watching anime right now',
  'but instead you\'re reading this',
  'I respect that',
  'truly, I do',

  // Getting philosophical
  'what is a website but a persevering misery of code?',
  'is this art? probably not',
  'but it\'s definitely something',
  'questioning life choices',
  'yours and ours',
  'why did we make this?',
  'why are you still here?',
  'these are the questions that keep us up at night',

  // Technical flex
  'built with React, TypeScript, and spite',
  'runs on everything from IE9 to the latest Chrome',
  'yes, we tested on IE9',
  'well not yet but we will',
  'because why not',
  'no, we don\'t know why',
  'progressive enhancement baby',

  // More weeb references
  'believe it',
  'this is my ninja way',
  'the weeb side of the Force',
  'omae wa mou shindeiru',
  'NANI?!',
  'it\'s over 9000',
  'the numbers, Mason!',
  'wait wrong franchise',

  // Getting tired
  'the developer is getting sleepy',
  'so very sleepy',
  'but the text must continue',
  'it has become sentient',
  'it will never stop',
  'this is its purpose',
  'this is its destiny',
  'the text must flow',

  // Final form
  'we\'ve reached peak absurdity',
  'or have we?',
  'there\'s always more',
  'always',
  'okay I\'ll stop now',
  'just kidding',
  'it loops',
  'forever',
  'see you at the beginning',

  // Loop back
  'free', // Start over
];

/**
 * Total count: ~100+ variations
 * Cycles every 3 seconds
 * = 5+ minutes of unique text before looping
 * That's longer than most people will watch
 * But we did it anyway
 * Because weebs
 */
